/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignUpCredentials
 */
export interface SignUpCredentials {
    /**
     * 
     * @type {string}
     * @memberof SignUpCredentials
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof SignUpCredentials
     */
    password?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SignUpCredentials
     */
    agreementTermsOfService?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SignUpCredentials
     */
    agreementPrivacyPolicy?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SignUpCredentials
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof SignUpCredentials
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof SignUpCredentials
     */
    phone?: string;
}

/**
 * Check if a given object implements the SignUpCredentials interface.
 */
export function instanceOfSignUpCredentials(value: object): value is SignUpCredentials {
    return true;
}

export function SignUpCredentialsFromJSON(json: any): SignUpCredentials {
    return SignUpCredentialsFromJSONTyped(json, false);
}

export function SignUpCredentialsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignUpCredentials {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'password': json['password'] == null ? undefined : json['password'],
        'agreementTermsOfService': json['agreementTermsOfService'] == null ? undefined : json['agreementTermsOfService'],
        'agreementPrivacyPolicy': json['agreementPrivacyPolicy'] == null ? undefined : json['agreementPrivacyPolicy'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function SignUpCredentialsToJSON(json: any): SignUpCredentials {
    return SignUpCredentialsToJSONTyped(json, false);
}

export function SignUpCredentialsToJSONTyped(value?: SignUpCredentials | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'password': value['password'],
        'agreementTermsOfService': value['agreementTermsOfService'],
        'agreementPrivacyPolicy': value['agreementPrivacyPolicy'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'phone': value['phone'],
    };
}

